import type { UpdateSerieRequest } from '@/api/generated/schemas';
import type { SerieDetailFormValues } from './serieDetailFormSchema';
import { toSerieTransportApi } from '../internal/serieLayers';

/** Transformace hodnot formuláře editace seriálu na API request `UpdateSerie`. */
export function toUpdateSerieRequestBody(values: SerieDetailFormValues): UpdateSerieRequest {
  const note = values.note.trim();
  return {
    name: values.name.trim(),
    transportType: toSerieTransportApi(values.transportType),
    capacityPerTerm: Number(values.capacityPerTerm),
    mainProgramLengthDays: Number(values.mainProgramLengthDays),
    note: note.length > 0 ? note : null,
    defaultCostCurrency: values.defaultCostCurrency ? values.defaultCostCurrency : null,
  };
}
